import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col } from 'react-bootstrap';
import { handleAddonQuantitySum, handleGetAddons_list } from './orderModel';

const AddonsStep = ({ addonOptions, setAddonOptions,sizeOptions,quote }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (addonOptions?.length <= 0) {
      handleGetAddons_list({ setLoading, setAddonOptions,quote });
    }
  }, []);

  // Toggle checkbox checked state on card click
  const handleCardClick = (id) => {
    const updatedAddons = addonOptions.map((addon) => {
      if (addon.id === id) {
        let qty=handleAddonQuantitySum(sizeOptions);        
        return {
          ...addon,          
          addon_qty: addon?.addon_qty > 0 ? 0 : qty,
          addons_amount:Number((addon?.addon_qty > 0 ? 0 : qty) * Number(addon?.addons_price)).toFixed(2)
        };
      }
      return {...addon};
    });    
    setAddonOptions(updatedAddons);
  };

  return (
    <div>        
      {loading ? (
        <div className="text-center my-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        addonOptions.map((item) => {
          const checked = item?.addon_qty > 0;
          return (
            <Card
              key={item.id}
              className="mb-2"
              style={{ cursor: 'pointer', userSelect: 'none' }}
              onClick={() => handleCardClick(item.id)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleCardClick(item.id);
                }
              }}
              tabIndex={0} // Make card focusable for accessibility
              role="checkbox"
              aria-checked={checked}
            >
              <Card.Body className="py-2 px-3">
                <Row className="align-items-center">
                  <Col xs={1} className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={checked}
                      readOnly
                      tabIndex={-1} // prevent tabbing into the checkbox itself
                      id={`addon-checkbox-${item.id}`}
                    />
                  </Col>
                  <Col xs={7}>
                    <Form.Label
                      htmlFor={`addon-checkbox-${item.id}`}
                      className="mb-0 fw-semibold"
                      style={{ cursor: 'pointer' }}
                    >
                      {item?.addon_name}
                    </Form.Label>
                  </Col>
                  <Col xs={4} className="text-end text-muted fw-bold">
                    ₹{item?.addons_price}
                  </Col>
                </Row>
              </Card.Body>
              <style jsx>{`
                .card:hover {
                  background-color: #f8f9fa; /* light gray on hover */
                }
              `}</style>
            </Card>
          );
        })
      )}
    </div>
  );
};

export default AddonsStep;
